import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function Odoo() {
  useEffect(() => {
    document.title = "Managed Odoo Server Solutions for Fast and Secure Operations";
        sal();
      }, []);
  return (
    <>
      <Helmet>
        <title>Managed Odoo Server Solutions for Fast and Secure Operations</title>
        <meta name="description" content="Get reliable managed Odoo server solutions to optimize your business operations, enhance security, and boost overall server performance efficiently today now!" />
        <meta name="keywords" content="Odoo Windows Server, Odoo Server, Managed Odoo Server Solutions" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/odoo-server`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/odoo-server`} />
        <meta property="og:title" content="Customized Odoo Hosting for Enterprise-Grade Efficiency" />
        <meta property="og:description" content="Get tailored, secure Odoo Hosting engineered for enterprise-level efficiency. Scalable and reliable type of hosting to fulfill all your ERP-based requirements." />
      </Helmet>
      <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="text-center">
                        <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Enterprise-Ready. Odoo-Powered.</span>
                        <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        For Every Sleepless Founder: Odoo Hosting That Works</h1>
                        <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Ever think that tech stuff is always too robotic, too complicated, and never really understands your situation? With the help of Odoo Hosting, businesses hit different. No struggle, no drama-only hosting that’s there for you, 24/7.</p>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <Link to="#" className="btn btn-primary btn-arrow btn-arrow-lg btn-lg fs-14 fw-semibold rounded open-live-chat btn-height">
                                <span className="btn-arrow__text">
                                    Talk to an Expert
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
      <div className="pt-100 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                  <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Odoo, Engineered To Scale.</small>
                    <h2 className="mb-4">From Complicated to Sorted: Hosting That Fits You</h2>
                  </div>
                  <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                        <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/flash-install.webp" /></div>
                        <h6 className="mb-4">Flash Install</h6>
                        <p className="mb-0">Begin with Odoo Hosting in a single click-no struggle, no more waiting, only quick access.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/global-hubs.webp" /></div>
                        <h6 className="mb-4">Global Hubs</h6>
                        <p className="mb-0">With our managed Odoo hosting, get fully stable US-based data center connections.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/here-for-you.webp" /></div>
                        <h6 className="mb-4">Here for You</h6>
                        <p className="mb-0">Get 24/7 help for managed Odoo hosting, with modules powered by the OpenERP community.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/restored-secured.webp" /></div>
                        <h6 className="mb-4">Restored & Secured</h6>
                        <p className="mb-0">With our dedicated Odoo hosting, you get timely backups & data restore solutions.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/live-always-running.webp" /></div>
                        <h6 className="mb-4">Live & Always Running</h6>
                        <p className="mb-0">Get a high uptime guarantee to always keep your business live with our Odoo hosting plans.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/odoo-powerhouse.webp" /></div>
                        <h6 className="mb-4">Odoo Powerhouse</h6>
                        <p className="mb-0">Our server supports multiple versions, like 17/16/15/14/13/12 that changes your operations.</p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <section className="pb-100">
        <div className="container">
            <div className="bg-white px-8 py-10 rounded-3">
                <div className="row align-items-center g-4">
                    <div className="col-lg-5">
                        <img src="/images/odoo-server-run-your-brand.webp" alt="image" className="img-fluid sal-animate" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                    </div>
                    <div className="col-lg-7 ipad-mt">
                        <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                              <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Business, Simplified
                            </small>
                        </div>
                        <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Odoo Server: Run Your Brand, Not After Tools</h2>
                        <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Sick of switching between different applications every time? Odoo server keeps sales, finance, and processes linked, so you work smarter, save your valuable time, and grow quickly.</p>
                        <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height sal-animate mt-5" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                              <span className="btn-arrow__text">
                                  Free Trial 
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <div className="pb-100">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/odoo-server-like-home.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Rule Your Server, Your Way.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Umm… An Odoo Server That Feels Like Home to You
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Just four flexible tiers. One solid Odoo Server. Begin small with a completely free 7-day trial and check out how far your business can go. Scale anytime, anywhere you wish for it. The main question is… are you fully ready to see what your business can do? 
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Your Workflows, Supercharged.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Odoo Hosting: The Glow-Up Your Business Squad Needed
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Ever think that your whole team is running in a loop, wasting hours on messy tasks? With our Odoo, that whole mess is gone. Everything your team needs-data and insights-is completely smooth. Decision-making gets smoother, tasks feel lighter? Yeah, it really happens.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/cpanel-img-4.png" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

      <section>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Odoo That Thinks Big-Just Like You.
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Just Chill, Our Odoo Self-Hosted is Attack-Free!!</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Your cPanel HQ</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/cpanel-hq.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Manage your Odoo server with full comfort-start, transfer files, and instant full-time access.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Flex & Grow</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/flex-grow.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">With our Odoo hosting, scale anytime to meet your needs-powered by a true partnership.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Bubble Mode Odoo</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/bubble-mode-odoo.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Each Odoo site simply runs in its own container, always keeping it protected from threats that really hit shared hosting.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">DDoS? Nahhhh!!</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/ddos-nah.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Keep your Odoo site safe-our DDoS protection blocks all malicious traffic so you can focus on your work, not downtime.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Web Application Firewall??</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/web-application-firewall.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Malicious traffic? Nah, not with us. Our WAF filters it all, always keeping your Odoo site live, secure, and running smoothly.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">SSL On, Stress Off</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/ssl-on-stress-off.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Protect it. Rank it. Run it.” Your Odoo site stays safe with the help of a free SSL certificate & gets all love from Google.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="simple-box-section pt-100 pb-100">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Built For Scale. Shaped For You.</span>
                                      <h4 className="mb-4">
                                          Odoo Hosting Mode: Hype x Totally Secure
                                      </h4>
                                      <p className="mb-6">
                                        Odoo packs every one of your business necessities-inventory, CRM, eCom, accounting, POS, projects. With the help of hosting that really supports every ERP version, personalized applications, and 40k+ third-party tools, your whole system stays quick. 
                                      </p>
                                      <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded btn-height me-sm-2">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              +91-7737300013
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                      <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded btn-height ms-sm-2 mt-sm-0 mt-4 open-live-chat">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Talk to an Expert
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
    </>
  );
}
